module.exports = __webpack_public_path__ + "static/media/mask (4).aac29f20.png";